import {
  BillingType,
  CarrierCodeType,
  HistoryTrackingResponse,
  PackageItem,
  PackageType,
  PartItem,
  ShipFrom,
  ShipmentEcommerceType,
  ShipStatus,
  ShipTo,
  SignatureType,
} from '@/features/shipment/types';
import { UploadDocument } from '@/features/shipment/types/documentType';

export enum ActionsException {
  ShipmentIsInTransitException = 'ShipmentIsInTransitException'
}

export enum TrackingSubStatus {
  Weather = 'Weather',
  Pickup = 'Pickup',
  OutForDelivery = 'OutForDelivery',
  Lost = 'Lost',
  Damaged = 'Damaged',
  Customs = 'Customs',
  Delivered = 'Delivered',
  Returned = 'Returned',
  Created = 'Created',
  ReceiverNotAvailable = 'ReceiverNotAvailable',
  Exception = 'Exception',
  InTransit = 'InTransit',
}

export enum TrackingScanStatus {
  Intransit = 'Intransit',
  Created = 'Created',
  Delivered = 'Delivered',
  Exception = 'Exception',
  None = 'None'
}

export interface HistoryPackageItem extends PackageItem {
  shipStatus: keyof typeof ShipStatus,
  lastScan: string,
  carrierTrackingNumber: string,
  userDefinedPackageType?: string,
}

export interface HistoryItemType {
  carrierCode: keyof typeof CarrierCodeType,
  serviceLevel?: string,
  selectedService?: string,
  serviceName: string,
  packageType: keyof typeof PackageType,
  shipDateTime: string,
  trackingNumber: string,
  carrierTrackingUrl?: string,
  myAccount: boolean,
  myAccountNumber?: string,
  hasComments: boolean,
  username: string,
  createdBy: string,
  fromAddress: ShipFrom,
  toAddress: ShipTo,
  packages: HistoryPackageItem[],
  deliveryEmail?: string,
  billing: {
    account: string,
    billingType: keyof typeof BillingType
  }
  quotedPrice: string,
  deleted: boolean,
  signatureOption: keyof typeof SignatureType,
  onTime: string,
  cutoffTime?: string,
  reference?: string,
  comment?: string,
  isDocumentsOnly?: boolean,
  commercialInvoice?: {
    broker: {
      name: string,
    },
    customsParts: PartItem[],
    declarationStatement: string,
    currencyCode: string,
    reasonForExport: string,
    remarks: string,
    generalDescriptionOfGoods: string,
    taxId?: string,
  },
  ecommerce?: ShipmentEcommerceType,
  invoiceNumber?: string,
  actualPrice?: string,
  isReturnShipment: boolean;
  isLabelFree: boolean;
  isBoxFree: boolean;
  qrCode?: string[];
  qrCodeExpiryDate?: string;
  uploadDocuments?: UploadDocument[];
}

export interface HistoryCommentType {
  date: string,
  text: string,
  username: string,
  id: string,
}

export interface TrackingScan {
  scanTime: string,
  status: keyof typeof TrackingScanStatus,
  substatus: keyof typeof TrackingSubStatus,
  location: string,
  description: string,
}

export interface TrackingDetailsType {
  trackingNumber: string,
  carrierTrackingNumber: string,
  carrierCode: keyof typeof CarrierCodeType,
  phone: string,
  signedBy: string,
  location: string,
  signatureUrl?: string,
  trackingScans: TrackingScan[]
}

export interface HistoryState {
  historyItems: HistoryItemType[],
}

export interface DeleteShipmentResponse extends HistoryTrackingResponse {
  exceptionType?: string,
}

export interface ShipmentSummaryItem {
  count: number,
  status: keyof typeof ShipStatus
}
